// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"7218d4f68d1fc641ced1","883":"1edcf0022d2f9e92d03c"}[chunkId] + ".js";
};